/** 设备性能分级：low = 触屏/低内存设备，降级粒子/拖尾/模糊 */
export type PerfTier = 'high' | 'low';

export function getPerfTier(): PerfTier {
  if (typeof window === 'undefined') return 'high';
  const coarse = window.matchMedia?.('(pointer: coarse)').matches;
  const mem = (navigator as unknown as { deviceMemory?: number }).deviceMemory;
  const small = window.innerWidth < 700;
  if (coarse || small || (mem !== undefined && mem <= 4)) return 'low';
  return 'high';
}
